export default "__VITE_ASSET__854d1fd3__"